<template>
  <div>404 Not Found</div>
</template>

<script>
export default {
  setup() {
    return {};
  }
};
</script>

<style lang="scss" scoped></style>
